import { first as _first, last as _last, chunk as _chunk, count as _count, equals as _equals, includesSlice as _includesSlice, startsWith as _startsWith, endsWith as _endsWith, groupBy as _groupBy, keyBy as _keyBy, orderBy as _orderBy, random as _random, shuffle as _shuffle, split as _split, unique as _unique, uniqueBy as _uniqueBy, partition as _partition, filterMap as _filterMap, } from "../array.ts";
Array.prototype.first = function first() {
    return _first(this);
};
Array.prototype.last = function last() {
    return _last(this);
};
Array.prototype.random = function random(remove = false) {
    return _random(this, remove);
};
Array.prototype.count = function count(ele) {
    return _count(this, ele);
};
Array.prototype.equals = function equals(another) {
    return _equals(this, another);
};
Array.prototype.includesSlice = function includesSlice(slice) {
    return _includesSlice(this, slice);
};
Array.prototype.startsWith = function startsWith(prefix) {
    return _startsWith(this, prefix);
};
Array.prototype.endsWith = function endsWith(suffix) {
    return _endsWith(this, suffix);
};
Array.prototype.split = function split(delimiter) {
    return _split(this, delimiter);
};
Array.prototype.chunk = function chunk(length) {
    return _chunk(this, length);
};
Array.prototype.unique = function unique() {
    return _unique(this);
};
Array.prototype.uniqueBy = function uniqueBy(fn) {
    return _uniqueBy(this, fn);
};
Array.prototype.shuffle = function shuffle() {
    return _shuffle(this);
};
Array.prototype.toShuffled = function toShuffled() {
    return this.slice().shuffle();
};
if (!Array.prototype.toReversed) {
    Array.prototype.toReversed = function toReversed() {
        return this.slice().reverse();
    };
}
if (!Array.prototype.toSorted) {
    Array.prototype.toSorted = function toSorted(fn) {
        return this.slice().sort(fn);
    };
}
Array.prototype.orderBy = function orderBy(key, order = "asc") {
    return _orderBy(this, key, order);
};
Array.prototype.groupBy = function groupBy(fn, type = Object) {
    return _groupBy(this, fn, type);
};
Array.prototype.keyBy = function keyBy(fn, type = Object) {
    return _keyBy(this, fn, type);
};
Array.prototype.partition = function partition(predicate) {
    return _partition(this, predicate);
};
Array.prototype.filterMap = function filterMap(fn) {
    return _filterMap(this, fn);
};
//# sourceMappingURL=array.js.map